import React from "react";
import { Box, Typography, Container } from "@mui/material";
import ConatctChat from "../../CommonPage/ConatctChat/ConatctChat";

const ContactUs = () => {
  return (
    <Box>
      {/* Top Banner Section */}
      <Box
        sx={{
          height: { xs: "75vh", md: "100vh" },
backgroundImage: "url(/Images/fulll.svg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          textAlign: "center",
          px: 2,
          zIndex: 1,
        }}
      >
        {/* Optional Overlay */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundColor: "transparent",
          }}
        />

        {/* Content */}
        <Container
          sx={{
            position: "relative",
            zIndex: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <Box
              component="img"
              src="/Images/contactLogo.png"
              alt="logo"
              sx={{
                height: { xs: 50, sm: 60, md: 70 },
                width: { xs: 50, sm: 60, md: 70 },
              }}
            />

            <Typography
              variant="h2"
              sx={{
                fontWeight: "bold",
                mt: 4,
                color: "#000",
                fontSize: {
                  xs: "1.75rem",
                  sm: "2.5rem",
                  md: "3rem",
                  lg: "4.5rem",
                },
              }}
            >
             Contact our friendly team
            </Typography>

            <Typography
              variant="h5"
              sx={{
                maxWidth: 600,
                mt: 3,
                mx: "auto",
                color: "#667085",
                fontSize: {
                  xs: "1rem",
                  sm: "1.25rem",
                  md: "1.8rem",
                },
              }}
            >
            Let us know how we can help.
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* Overlapping Cards Section */}
      <Box sx={{ mt: { xs: -10, md: -15 }, position: "relative", zIndex: 3 }}>
        <ConatctChat />
      </Box>
    </Box>
  );
};

export default ContactUs;
